<div class="row">
  <div class="col-lg-12">
    <kla-title [lineConfig]="lineConfig" [config]="config.title"></kla-title>
  </div>
  <div class="col-lg-12 chart" #panel>
    <kla-bar-chart [width]="width" [height]="height" [config]="config.barChart"
      [attr.role]="config.chartAltText ? 'img' : null"
      [attr.aria-label]="config.chartAltText || null"
      [attr.aria-hidden]="config.chartAltText ? null : 'true'"></kla-bar-chart>
  </div>
  <div class="col-lg-11 chart" *ngIf="config.audio">
    <kla-audio class="audio"
               [url]="config.audio.url"
               [image]="config.audio.image"
               [text]="config.audio.text">
    </kla-audio>
  </div>
</div>
